// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "./assets/" + chunkId + "." + {"83":"1a59620a","259":"f6adb013","272":"3816614c","439":"690dd65b","861":"b458f2a0","891":"3a014ee9"}[chunkId] + ".js";
};